/* 
  评卷教师选拔
*/
import request from "@/utils/request";

//评卷员数量/选拔数量
export function getSelectNum(projectId) {
  return request({
    url: `/markteacher/markTchSelect/getSelectNum?projectId=${projectId}`,
    method: "get",
  });
}

//获取评卷教师选拔页面参数
export function getParam() {
  return request({
    url: "/markteacher/markTchSelect/getParam",
    method: "get",
  
  });
}

//获取评卷教师选拔分页列表
export function getMarkTchSelect(params) {
  return request({
    url: "/markteacher/markTchSelect/getMarkTchSelect",
    method: "get",
    params
  });
}

//自动选拔
export function autoSelect(projectId) {
  return request({
    url: "/markteacher/markTchSelect/autoSelect",
    method: "get",
    params:{
      projectId
    }
  });
}

//确定或取消选拔
export function confirmOrCancelSelect(data) {
  return request({
    url: "/markteacher/markTchSelect/confirmOrCancelSelect",
    method: "post",
    data
  });
}

//配置参数
export function editParam(data) {
  return request({
    url: "/markteacher/markTchSelect/editParam",
    method: "post",
    data
  });
}

//根据科目获取选拔参数信息
export function getSelectParamVo(params) {
  return request({
    url: "/markteacher/markTchSelect/getSelectParamVo",
    method: "get",
    params
  });
}